import { I18nNamespace } from 'constants/i18n.const';
import { DListResponse } from 'models/common.model';

export enum PaymentMethodEnum {
  CASH = 1,
  MOMO = 2,
  TESTPC = 3,
  RETAKE_PHOTO = 4,
  TEST_FRAME = 5,
  VNPAY = 6,
}

export enum PINCODE_STATUS {
  TimeIsReched = '001', // Thời gian sử dụng chức năng này đã kết thúc
  PinIsncorrect = '002', // Mã Pin không đúng!
  PinIsCorrect = '003', // Mã Pin hợp lệ!
  PinIsncorrectWithBooth = '004', // Bạn không có quyền sử dụng tính năng này!
  OverTestsNumber = '005', // Gian hàng đã test quá số lần cho phép!
}

export enum VOUCHER_STATUS {
  Used = '101', // Mã đã sử dụng
  Expired = '102', // Mã đã hết hạn sử dụng
  NotApply = '103', // Mã không được áp dụng cho cửa hàng
  Success = '200', // Thành công
  NotValid = '105', // Không hợp lệ
  PleaseUseTrueCurrency = '106', // Vui lòng sử dụng đúng tiền tệ
}

export const PINCODE_STATUS_MESSAGE_MAPPING: Partial<
  Record<PINCODE_STATUS, string>
> = {
  [PINCODE_STATUS.TimeIsReched]: `${I18nNamespace.COMMON}:pincodeErrorStatus.timeIsReched`,
  [PINCODE_STATUS.PinIsncorrect]: `${I18nNamespace.COMMON}:pincodeErrorStatus.pinIsncorrect`,
  [PINCODE_STATUS.PinIsncorrectWithBooth]: `${I18nNamespace.COMMON}:pincodeErrorStatus.pinIsncorrectWithBooth`,
  [PINCODE_STATUS.OverTestsNumber]: `${I18nNamespace.COMMON}:pincodeErrorStatus.overTestsNumber`,
};

export const VOUCHER_STATUS_MESSAGE_MAPPING: Partial<
  Record<VOUCHER_STATUS, string>
> = {
  [VOUCHER_STATUS.Used]: `${I18nNamespace.COMMON}:voucherErrorStatus.used`,
  [VOUCHER_STATUS.Expired]: `${I18nNamespace.COMMON}:voucherErrorStatus.expired`,
  [VOUCHER_STATUS.NotApply]: `${I18nNamespace.COMMON}:voucherErrorStatus.notApply`,
  [VOUCHER_STATUS.NotValid]: `${I18nNamespace.COMMON}:voucherErrorStatus.notValid`,
  [VOUCHER_STATUS.PleaseUseTrueCurrency]: `${I18nNamespace.COMMON}:voucherErrorStatus.pleaseUseTrueCurrency`,
};

export type TransactionModel = any;
export type FirstPushTransactionRequestModel = {
  id: string;
  deposit: number;
  voucherCode?: string;
  status?: number;
  code?: string;
  recordAt?: string;
  createdTime?: string;
  uploadTime?: string;
  paymentMethod?: PaymentMethodEnum;
};

export type FirstPushTransactionResponseModel = DListResponse<boolean>;
